import useIsOmistaja from 'hooks/useIsOmistaja';

export default function IsOmistaja({
  children = null,
  fallback = null,
  toimisto,
}) {
  return useIsOmistaja(toimisto) ? children : fallback;
}
